import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';

import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';
import ApiRow from '../../Settings/apiRow'

import EcommOptions from '../ecommOptions'

import {ReactComponent as Check} from '../../../Images/check-solid.svg'


import BackArrow from '../../../Images/arrow-left.svg';

import './index.css';


class EcommerceConfig extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoad:true,
      coins_settings:{},
      on_order_creation:'True',
      on_order_complete:'True',
      img_base64:'',
      list_banks:[],
      api_keys:[],
      wallets:[],
      show:false,
      fromWallet:'',
      coinArr:[],
      currency: "",
      vex_fee: "1.0"
    }
  }
  addNotification(status,msg,type){
      store.addNotification({
        title: status,
        message: msg,
        type: type,
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 2500,
          onScreen: true
        }
      });
  }

  componentWillMount() {
    this.getEcommSettings()
    setTimeout(() => {
      if (this.state.currency === ''){
        this.setState({currency: 'mxn'})
      }
    }, 3000);
  }


  getEcommSettings(){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {

      Backend.general_get('get_wallets_settings',response.payload.r01,response=>{
        if(response.status.code == "18004") return this.props.data.history.push('/ecommerce/create')
        else if(response.status.code == '0') this.setState({coins_settings:response.payload.coins_settings, showLoad:false})
      })

      Backend.general_get('get_notifications_settings',response.payload.r01,response=>{
        if(response.status.code == '0')  this.setState({ ...response.payload.notifications })
      })

      Backend.general_get('get_general_settings',response.payload.r01,response=>{
        if(response.status.code == '0') {
          const {currency, vex_fee} = response.payload.general_settings
          this.setState({ ...response.payload.general_settings, currency, vex_fee })
        }
      });

      Backend.client_banks_list(localStorage.getItem('email'), localStorage.getItem('token'), 'approved',response.payload.r01, response => {
          if(response.status.code == '0') this.setState({list_banks:response.payload.list_banks})
      });

      Backend.get_ecomm_image(response.payload.r01, response =>{
        if(response.status.code == '0')
          this.setState({img_base64:'data:image/png;base64,'+response.payload.img_b64})
      })

    })
  }

  getSettingOptions (){
    let { acceptance_threshold , auto_fiat, fiat_bank, fiat_interval, url, currency } = this.state
    return { acceptance_threshold , auto_fiat, fiat_bank, fiat_interval, url, currency }
  }

  updateEcommSettings(){
    let { coins_settings , on_order_creation, on_order_complete } = this.state
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    this.setState({showLoad:true})
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", async response => {
      let walletPromise = new Promise(resolve => Backend.update_ecomm_wallets(response.payload.r01,coins_settings,resolve))
      let notificationPromise = new Promise(resolve => Backend.update_ecomm_notifications(response.payload.r01, on_order_creation, on_order_complete, resolve))
      let generalPromise = new Promise(resolve => Backend.update_general_settings(response.payload.r01, this.getSettingOptions(), resolve))
      let promises = [walletPromise, notificationPromise, generalPromise]
      if(this.state.ecomm_img){
        promises.push(
          new Promise(resolve => Backend.upload_file(localStorage.getItem('email'), localStorage.getItem('token'),this.state.ecomm_img,'f_ecomm_logo',response.payload.r01, resolve))
        )
      }
      let responses =  await Promise.all(promises)
      this.setState({showLoad:false})
      let success = true
      responses.forEach((response, i) => {
        if(response.status.code !== '0') return success = false
      });
      if(success) this.addNotification("Success!",'Settings updated correctly',"success");
      else this.addNotification("Error!",'Something went wrong, try again later',"danger");

    })
  }


  renderCoins(){
    let coins = this.state.coins_settings
    return Object.keys(coins).map((i) => {
      let active = (coins[i].status == 'enabled')
      return(
        <Col xl={4}>
          <Button
            onClick={()=>{
              let { coins_settings } = this.state;
              coins_settings[i].status = active ? 'disabled' : 'enabled'
              this.setState({coins})
            }}
            className={'ecomm-coin-button flex space-between' + (active?' selected':'')}
            >
            <img  height="40" src={require("../../../CryptoIcons/" + i + ".svg")}/>
            <span>{coins[i].coin_name || i}</span> <span>{i}</span>
          </Button>
        </Col>
      )
    })
  }

  optionStyle(state,id){
    if(state == id) return 'ecommerce_multi_option active'
    else return 'ecommerce_multi_option'
  }

  renderApiKeys(){
    return this.state.api_keys.map(item => {
      return(
          <ApiRow {...item} noLastUse/>
      )
    })
  }

  render(){
    let { ecomm } = this.props.traductions
    let { acceptance_threshold, on_order_creation, on_order_complete } = this.state
    let boolCreation = (on_order_creation == 'True')
    let boolComplete = (on_order_complete == 'True')
    return(
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10, }}>
          <Container className='ecommerce_signup'>
            <div>
              <div className='back-button' style={{width:110, cursor:'pointer', marginTop:-15, marginBottom:10}} onClick={()=>this.props.data.history.push('/ecommerce')}>
                <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
                {ecomm.goBack}
              </div>
            </div>
            <p className='dark-text medium-dms text-25'>{ecomm.b_settings}</p>

            <div className='container-transactions'>
              <div className='flex' style={{marginBottom:20}}>
                <div style={{borderRadius:100, height:100, width:100, display:'inline-block', overflow:'hidden', position:'relative'}}>
                  {
                    this.state.img_base64
                    ?<Image style={{height:100, width:100}} src={this.state.img_base64}/>
                    :''
                  }
                  <Form.Control
                      style={{ display:'none' }}
                      ref={fileInput => this.fileInput = fileInput}
                      id="img"
                      type="file"
                      name="user[image]"
                      multiple={false}
                      accept={"image/png, image/jpeg, image/jpg"}
                      size="2000000"
                      onChange={() =>  this._onChangeImage() }
                  />
                  <div className='ecomm-img-button' onClick={()=>this.fileInput.click()}>
                    Change
                  </div>
                </div>
                <div style={{marginLeft:30}}>
                  <p className='font-22 blue-text medium-dms'>{ecomm.myecomm} </p>
                  <p className='font-20 gray-text normal-dms'>{this.state.ecomm} </p>
                </div>
              </div>

              <p className='dark-text medium-dms'>{ecomm.apititle}</p>
              <div className='neg-margin flex wrap justify-start w100'>
                <table className="table-container-wallets-generals">
                  <thead>
                    <tr>
                      <th className="header-table-wallets-generals fixxxed">API Key</th>
                      <th className="header-table-wallets-generals fixxxed">{ecomm.status}</th>
                      <th className="header-table-wallets-generals fixxxed">API Secret</th>
                      <th className="header-table-wallets-generals fixxxed">API Totp</th>
                      <th className="header-table-wallets-generals fixxxed"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderApiKeys()}
                  </tbody>
                </table>
                <a target="_blank" href="https://apidocsv1.wirebit.com/ecomm" style={{paddingLeft:5}}>{ecomm.documentation}</a>
              </div>

              <div className='ecommerce_divider'/>


              <p className='dark-text medium-dms'>{ecomm.select_cripto}</p>
              <Row style={{paddingRight:'15px'}}>
                {this.renderCoins()}
              </Row>


              <div className='ecommerce_divider'/>


              <p className='dark-text medium-dms'>{ecomm.tolerance}</p>
              <p className='gray-text normal-dms'>{ecomm.select_tolerance} </p>
              <div className='ecomm-slider'>
                <div onClick={()=>this.setState({acceptance_threshold:'5'})} className={(acceptance_threshold == '5')?'ecomm-slider-button selected':'ecomm-slider-button'}>
                  <div className='ecomm-slider-dot'>
                      <div>95%</div>
                  </div>
                </div>

                <div onClick={()=>this.setState({acceptance_threshold:'2'})} className={(acceptance_threshold == '2')?'ecomm-slider-button selected':'ecomm-slider-button'}>
                  <div className='ecomm-slider-dot'>
                      <div>98%</div>
                  </div>
                </div>

                <div onClick={()=>this.setState({acceptance_threshold:'0'})} className={(acceptance_threshold == '0')?'ecomm-slider-button selected':'ecomm-slider-button'}>
                  <div className='ecomm-slider-dot'>
                      <div className='last'>100%</div>
                  </div>
                </div>
              </div>


              <div className='ecommerce_divider'/>
              <p className="dark-text medium-dms">{ecomm.select_currency}</p>
              <div style={{display: 'flex'}}>
                <div onClick={()=> this.setState({currency: 'usd'})}
                  className={this.state.currency === 'usd' ? 'ecommerce_multi_option active': 'ecommerce_multi_option'}
                >
                  V-USD
                </div>
                <div
                style={{marginLeft: '20%'}}
                onClick={()=> this.setState({currency: 'mxn'})}
                className={this.state.currency === 'mxn' ? 'ecommerce_multi_option active': 'ecommerce_multi_option'}>
                  V-MXN
                </div>
              </div>

              <div className='ecommerce_divider'/>


              <EcommOptions {...this.props} {...this.state} setState={this.setState.bind(this)} noBank={this.state.list_banks.length == 0} vexFee={this.state.vex_fee} />


              <div className='ecommerce_divider'/>


              <div>
                <p className='dark-text medium-dms'>{ecomm.notification_options}</p>
                <div className='ecomm-checkbox'>
                  <div className={boolCreation?'selected':''} onClick={()=>this.setState({on_order_creation:boolCreation?'False':'True'})}>
                    <Check/>
                  </div>
                  <span className='gray-text normal-dms'>
                    {ecomm.mail_create}
                  </span>
                </div>

                <div className='ecomm-checkbox'>
                  <div className={boolComplete?'selected':''} onClick={()=>this.setState({on_order_complete:boolComplete?'False':'True'})}>
                    <Check/>
                  </div>
                  <span className='gray-text normal-dms'>
                    {ecomm.mail_complete}
                  </span>
                </div>
              </div>


              <div className='ecommerce_divider'/>


              <div>
                <p className='dark-text medium-dms'>{ecomm.url}</p>
                <div style={{marginBottom:10}}>
                  <Form.Label className="ecommerce_input_label">URL:</Form.Label>
                  <Form.Control
                    style={{ height: 40 }}
                    className="ecommerce_input"
                    type="text"
                    placeholder="https://www.myecommerce.com"
                    value={this.state.url}
                    onChange={(url) => { this.setState({ url: url.target.value }) }}
                    />
                </div>
              </div>

              <Button className='ecommerce_signup_button medium-dms' disabled={this.state.showLoad} onClick={()=>this.updateEcommSettings()}>
                {
                  (this.state.showLoad)
                    ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                    : ecomm.save
                }
              </Button>

            </div>

          </Container>
        </div>

      </div>
    )
  }

  _onChangeImage(){
      var file = this.fileInput.files[0];
      var fileType = file?.name?.split(".")[file.name?.split(".").length-1].toLowerCase()
      var reader = new FileReader();
      reader.readAsDataURL(file);
      if (file.size > 8000000) {
          document.getElementById("img").value = "";
          this.addNotification("Error!","Image exceeds 8MB.","danger");
      }else if (fileType != 'jpeg' && fileType != 'png' && fileType != 'jpg' && fileType != 'pdf'){
          document.getElementById("img").value = "";
          this.addNotification("Error!", "Only .jpeg .png or .pdf files are acceptable","danger");
      }else {
          reader.onloadend = function (e) {
              var image_split = [reader.result][0];
              this.setState({
                ecomm_img:{
                  img: [reader.result],
                  base64: image_split.split(",")[1],
                  base64Type: fileType,
                  imgFile: file,
                  imgName: file?.name,
                  correctUpload:false
                },
                img_base64:[reader.result][0]
              })
          }.bind(this);
      }
  }
}
export default EcommerceConfig
